export default __webpack_public_path__ + "static/media/porduct-tour-card.a8abb1c9.svg";